import { CdkDrag, CdkDragEnd, CdkDragHandle } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { getAnimationAppearDisappear } from '@examdojo/animation';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { PlatformService } from '@examdojo/platform';
import { ImageComponent } from '@examdojo/ui/image';
import { ChatSuggestionsService } from '../../chat';

@Component({
  selector: 'dojo-sensei-fab',
  imports: [CdkDrag, CdkDragHandle, ImageComponent, ButtonComponent, IconComponent],
  templateUrl: './sensei-fab.component.html',
  styleUrl: './sensei-fab.component.scss',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [getAnimationAppearDisappear()],
})
export class SenseiFabComponent {
  constructor(
    private readonly chatSuggestionsService: ChatSuggestionsService,
    private readonly platformService: PlatformService,
  ) {}

  readonly senseiImageType = input<'neutral' | 'wrong' | 'correct'>('neutral');
  readonly showSuggestions = input(false);

  readonly chatToggled = output<string | undefined>();

  readonly fabPosition = signal({ x: 0, y: 0 });
  private isDragging = false;
  private dragEndTime = 0;
  private readonly CLICK_PREVENT_DELAY = 200; // ms to prevent click after drag

  readonly senseiImagePath = computed(() => {
    const type = this.senseiImageType();
    return `assets/images/topic-practice/sensei/${type}-sensei.svg`;
  });

  readonly state = connectState({
    chatSuggestions: this.chatSuggestionsService.limitedChatSuggestions$,
    isMobile: this.platformService.isSmall$,
  });

  openMCQChat(suggestionValue?: string) {
    // Prevent click if it occurs shortly after drag end
    const timeSinceDragEnd = Date.now() - this.dragEndTime;
    if (this.isDragging || timeSinceDragEnd < this.CLICK_PREVENT_DELAY) {
      return;
    }

    this.chatToggled.emit(suggestionValue);
  }

  onFabDragStarted() {
    this.isDragging = true;
  }

  onFabDragEnded(event: CdkDragEnd) {
    const { x, y } = event.source.getFreeDragPosition();
    this.fabPosition.set({ x, y });

    // Update drag state to prevent click after drag
    this.isDragging = false;
    this.dragEndTime = Date.now();
  }
}
